import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ChangeDetectorRef,
  TemplateRef,
  ViewChild,
  Renderer2,
  ViewChildren,
  QueryList,
} from '@angular/core';
/*import { Http } from '@angular/http';*/
import { BrowserModule } from '@angular/platform-browser';
/*import { HttpModule } from '@angular/http';*/
import { CommonModule } from '@angular/common';
import { ValidationService } from '../../../shared/providers/validation.service';
import { ToastService } from '../../../shared/providers/toast.service';
import { CommonService } from '../../../shared/providers/common.service';
import { LoaderService } from '../../../shared/providers/loader.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import {
  IGuarantorMapping,
  ITenant,
} from '../../../shared/models/TenantModels';
import { ITypeInput } from '../../../shared/models/ITypeInput';
import { AuthenticationService } from '../../../shared/auth/authentication.service';
import { PropertyManagementService } from '../../../shared/providers/property-management.service';
import { ILookUp } from '../../../shared/models/LookUpOutputModel';
import { RatingAgency } from '../../../shared/enum/enum';
import { HttpClient } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';
import { MatSelect } from '@angular/material/select';

export interface IPropertyType {
  id: number;
  name: string;
  masterId?: number;
}

interface IGuarantor {
  id: number;
  name: string;
}

interface IDropDownData {
  value: number;
  display: string;
  TypeId: number;
}

@Component({
  selector: 'app-add-tenant',
  templateUrl: './add-tenant.component.html',
})
export class AddTenantComponent implements OnInit {
  isSubmit = false;
  @Input() modalRef: BsModalRef;
  @Input() tenantId: number;
  @Output() closeModal = new EventEmitter();
  @ViewChildren(MatSelect) matSelects!: QueryList<MatSelect>;
  modalHeaderText = 'Add Tenant';
  tenant = {} as ITenant;
  modalRefConfirmation: BsModalRef;
  user: any;
  URLValid = true;
  TypeList: ITypeInput[];
  propertyTypeList: IPropertyType[];
  subcategoryList: IPropertyType[];
  guarnatorList: string;
  gurantorCount: number = 0;
  sprRatingList: ILookUp[];
  moodysRatingList: ILookUp[];
  fitchRatingList: ILookUp[];
  /*guarantorList: IGuarantor[];*/
  guarantors: any[];
  gurantorIds: number[];
  ratingAgency = RatingAgency;
  defaultGuarantorText = {
    checked: 'item selected',
    checkedPlural: 'items selected',
    defaultTitle: 'Select Guarantor',
    searchEmptyResult: 'No results found...',
  };
  dropdownSettings = {
    lazyLoading: true,
    singleSelection: false,
    text: 'Select Guarantor',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    enableSearchFilter: true,
    classes: 'dropup dropup-inline',
    enableFilterSelectAll: false,
  };

  loadingTexts = Object.assign({}, this.defaultGuarantorText);
  noresultTexts = Object.assign({}, this.defaultGuarantorText);

  guarantorList = [];
  initLoadNum = 20;
  lastFilter: string = '';
  lazyLoadNum: number = 10;

  //defaultPropertyTypeText: IMultiSelectTexts = {
  //  checked: 'item selected',
  //  searchEmptyResult: 'Loading...',
  //  checkedPlural: 'items selected',
  //  defaultTitle: 'Select Business Type',
  //};
  defaultPropertyTypeSettings = {
    singleSelection: false,
    text: 'Select Business Type',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    enableSearchFilter: true,
    classes: 'myclass custom-class',
    enableFilterSelectAll: false,
  };

  //defaultSubcategoryText: IMultiSelectTexts = {
  //  checked: 'item selected',
  //  checkedPlural: 'items selected',
  //  defaultTitle: 'Select Subcategory',
  //  searchEmptyResult: 'No results found...',
  //};
  defaultSubcategorySettings = {
    singleSelection: false,
    text: 'Select Subcategory',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    enableSearchFilter: true,
    classes: 'myclass custom-class',
    enableFilterSelectAll: false,
  };

  constructor(
    private authService: AuthenticationService,
    private Toast: ToastService,
    private _propertyManagementService: PropertyManagementService,
    private Loader: LoaderService,
    private modalService: BsModalService,
    public Validation: ValidationService,
    private Common: CommonService,
    private cdRef: ChangeDetectorRef,
    private renderer: Renderer2,
  ) {}

  ngOnInit() {
    this.user = this.authService.user;
    this.getAllTypeList();
    this.bindRatings();
    if (!this.Validation.IsinValid(this.tenantId) && this.tenantId != 0) {
      this.modalHeaderText = 'Edit Tenant';
      this.Common.GetTenantDetails(this.tenantId).subscribe((res) => {
        this.tenant.Id = res['Id'];
        this.tenant.Name = res['Name'];
        this.tenant.URL = res['URL'];
        this.tenant.TypeId = res['TypeId'];
        this.tenant.SubcategoryId = res['SubcategoryId'];
        this.tenant.TickerSymbol = res['TickerSymbol'];
        let tenantGuarantor = res['GuarantorNames'];
        if (
          tenantGuarantor != null &&
          tenantGuarantor != '' &&
          tenantGuarantor != undefined
        ) {
          tenantGuarantor = tenantGuarantor.replace('\r\n', '\n');
          this.guarnatorList = tenantGuarantor;
          this.gurantorCount = res['GuarantorCount'];
        }
        this.getSubcategoryList(null);
      });
    } else {
      this.tenant.Id = null;
      this.guarantorSearch(this.initLoadNum, 0, 'null').then(
        (results) =>
          (this.guarantorList = results.map((o) => {
            return { id: o.GuarantorId, name: o.GuarantorName };
          }))
      );
      this.getGuarantor();
      this.modalHeaderText = 'Add Tenant';
    }
    this.tenant.MoodyRatingId = 0;
    this.tenant.FitchRatingId = 0;
    this.tenant.SPRatingId = 0;
  }

  ngAfterViewInit() {
    this.matSelects.forEach((matSelect) => {
      matSelect.openedChange.subscribe((isOpened) => {
        if (isOpened) {
          this.addClassToOverlayContainer();
        } else {
          this.removeClassFromOverlayContainer();
        }
      });
    });
  }

  addClassToOverlayContainer() {
    const overlayContainer = document.querySelector('.cdk-overlay-container');
    if (overlayContainer) {
      this.renderer.addClass(overlayContainer, 'custom-overlay-container');
    }
  }

  removeClassFromOverlayContainer() {
    const overlayContainer = document.querySelector('.cdk-overlay-container');
    if (overlayContainer) {
      this.renderer.removeClass(overlayContainer, 'custom-overlay-container');
    }
  }
  getAllTypeList() {
    this.Common.getTypeList().subscribe((response) => {
      if (response != null && response.length > 0) {
        this.propertyTypeList = response.map((o) => {
          return { id: o.Id, name: o.Type };
        });
      }
    });
  }

  getSubcategoryList(event: any) {
    if (this.tenant.TypeId.length > 0) {
      this.Common.getSubcategoryList(this.tenant.TypeId).subscribe((res) => {
        this.subcategoryList = res.map((o) => {
          return { id: o['Id'], name: o['Name'], masterId: o['MasterId'] };
        });
        this.changeCurrentSelection();
      });
    } else {
      this.subcategoryList = [];
      this.tenant.SubcategoryId = [];
      this.cdRef.detectChanges();
    }
  }

  changeCurrentSelection() {
    let Subcategory: number[] = [];
    if (this.subcategoryList != null && this.subcategoryList.length > 0) {
      this.subcategoryList.forEach((item) => {
        if (this.tenant.SubcategoryId?.indexOf(item.id) > -1) {
          Subcategory.push(item.id);
        }
      });
    }
    this.tenant.SubcategoryId = [];
    this.tenant.SubcategoryId = Subcategory;
    this.cdRef.detectChanges();
  }

  saveTenant() {
    if (
      this.modalRefConfirmation != null &&
      this.modalRefConfirmation != undefined
    ) {
      this.modalRefConfirmation.hide();
    }
    this.Loader.display(true);
    this.changeCurrentSelection();
    this.saveGuarantorRating();
    this.Common.saveTenant(this.tenant).subscribe((res) => {
      if (res['IsSuccess']) {
        this.Toast.addToast({
          title: 'Success',
          msg: 'Tenant Saved Successfully',
          timeout: 5000,
          theme: 'bootstrap',
          position: 'bottom-right',
          type: 'success',
        });
        this.tenant.Id = res['Id'];
        this.closeModal.emit(this.tenant);
        this.modalRef.hide();
      } else {
        this.Toast.addToast({
          title: 'Error Occurred',
          msg: res['ErrorMessage'],
          timeout: 5000,
          theme: 'bootstrap',
          position: 'bottom-right',
          type: 'error',
        });
      }
      this.Loader.display(false);
    });
  }

  hideModal() {
    this.tenant.Id = 0;
    this.closeModal.emit(this.tenant);
    this.modalRef.hide();
  }

  saveTenantModal(template: TemplateRef<any>, classes: any) {
    const config = {
      ignoreBackdropClick: true,
      class: 'modal-position ' + classes,
      keyboard: false,
      backdrop: true,
    };

    this.isSubmit = true;
    this.tenant.UserId = this.user.Id;
    let valid = true;
    if (this.Validation.IsinValid(this.tenant.Name)) {
      valid = false;
    }
    if (
      this.tenant.CreateGuarantor == true &&
      this.guarantors.find((j) => j.name == this.tenant.GuarantorName)
    ) {
      valid = false;
      this.Toast.addToast({
        title: 'Error Occurred',
        msg: 'Guarantor name already exists',
        timeout: 5000,
        theme: 'bootstrap',
        position: 'bottom-right',
        type: 'error',
      });
    }
    if (
      !this.Validation.IsinValid(this.tenant.URL) &&
      this.Validation.isUrlValid(this.tenant.URL) == false
    ) {
      this.URLValid = false;
      valid = false;
    } else {
      this.URLValid = true;
    }

    if (
      valid &&
      this.tenant.CreateGuarantor != true &&
      this.tenant.Id == null &&
      this.tenant.GuarantorId == null
    ) {
      this.modalRefConfirmation = this.modalService.show(template, config);
    } else if (
      valid &&
      (this.tenant.CreateGuarantor == true ||
        this.tenant.Id != null ||
        this.tenant.GuarantorId != null)
    ) {
      this.saveTenant();
    }
  }

  bindRatings() {
    this.Loader.display(true);
    this._propertyManagementService
      .getSAndPRatingList()
      .subscribe((response) => {
        this.sprRatingList = response.map((o) => {
          return { id: o.Id, description: o.Description };
        });
      });

    this._propertyManagementService
      .getMoodysRatingList()
      .subscribe((response) => {
        this.moodysRatingList = response.map((o) => {
          return { id: o.Id, description: o.Description };
        });
      });

    this._propertyManagementService
      .getFitchRatingList()
      .subscribe((response) => {
        this.fitchRatingList = response.map((o) => {
          return { id: o.Id, description: o.Description };
        });
        this.Loader.display(false);
      });
  }

  //onItemGuarantorSelect(event) {
  //  this.tenant.GuarantorId.push(event.id)
  //}

  onItemGuarantorSelect() {
    let Guarantor: number[] = [];
    this.guarantorList.forEach((item) => {
      if (this.tenant.GuarantorId.indexOf(item.id) > -1) {
        Guarantor.push(item.id);
      }
    });
    this.tenant.GuarantorId = [];
    this.tenant.GuarantorId = Guarantor;
  }

  onItemGuarantorDeSelect(event) {
    const index: number = this.tenant.GuarantorId.indexOf(event.id);
    if (index !== -1) {
      this.tenant.GuarantorId.splice(index, 1);
    }
  }

  saveGuarantorRating() {
    this.tenant.GuarantorRating = [];
    if (
      !this.Validation.IsinValid(this.tenant.SPRatingId) &&
      this.tenant.SPRatingId != 0
    ) {
      const rating = {
        RatingAgengyType: this.ratingAgency.SandPRating,
        RatingId: this.tenant.SPRatingId,
      };
      this.tenant.GuarantorRating.push(rating);
    }

    if (
      !this.Validation.IsinValid(this.tenant.MoodyRatingId) &&
      this.tenant.MoodyRatingId != 0
    ) {
      const rating = {
        RatingAgengyType: this.ratingAgency.MoodysRating,
        RatingId: this.tenant.MoodyRatingId,
      };
      this.tenant.GuarantorRating.push(rating);
    }

    if (
      !this.Validation.IsinValid(this.tenant.FitchRatingId) &&
      this.tenant.FitchRatingId != 0
    ) {
      const rating = {
        RatingAgengyType: this.ratingAgency.FitchRating,
        RatingId: this.tenant.FitchRatingId,
      };
      this.tenant.GuarantorRating.push(rating);
    }
  }

  guarantorSearch(
    quantity: number = this.initLoadNum,
    offset: number = 0,
    searchText
  ) {
    return lastValueFrom(this.Common.GetGuarantorBySearch(searchText))
      .then((results) => results.slice(offset, quantity + offset))
      .catch((error) => {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
      });
  }

  lastLength: number = 500;

  loadGuarantorData(event) {
    let filter: string = event.filter;
    let length = event.length;
    this.defaultGuarantorText = this.loadingTexts;

    if (filter !== this.lastFilter) {
      this.lastLength = 0;
      this.lastFilter = filter;
      this.guarantorList = [];
      this.guarantorSearch(this.initLoadNum, 0, filter)
        .then(
          (results) =>
            (this.guarantorList = results.map((o) => {
              return { id: o.GuarantorId, name: o.GuarantorName };
            }))
        )
        .then(() => (this.defaultGuarantorText = this.noresultTexts));
    } else if (length !== this.lastLength) {
      this.lastLength = length;
      this.guarantorSearch(this.lazyLoadNum, this.lastLength, filter)
        .then(
          (results) =>
            (this.guarantorList = this.guarantorList.concat(
              results.map((o) => {
                return { id: o.GuarantorId, name: o.GuarantorName };
              })
            ))
        )
        .then(() => (this.defaultGuarantorText = this.noresultTexts));
    }
  }

  getGuarantor() {
    this.Common.GetGuarantor().subscribe((response) => {
      if (response != null && response.length > 0) {
        this.guarantors = response.map((o) => {
          return { id: o.Id, name: o.Name };
        });
      }
    });
  }
}
